import { emailRegex } from "../constants/Variables";

const loginValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  return hasError;
};

const signupValidation = (obj, setInputError) => {
  console.log(obj, "objobjobjobjobj");

  let hasError = false;

  if (!obj.firstName) {
    setInputError((prev) => ({ ...prev, firstName: true }));
    hasError = true;
  }
  if (!obj.lastName) {
    setInputError((prev) => ({ ...prev, lastName: true }));
    hasError = true;
  }
  if (!obj.companyEmail) {
    setInputError((prev) => ({ ...prev, companyEmail: true }));
    hasError = true;
  }
  if (obj.companyEmail && !emailRegex.test(obj.companyEmail)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }
  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }
  if (!obj.confirmPass) {
    setInputError((prev) => ({ ...prev, confirmPass: true }));
    hasError = true;
  }

  return hasError;
};
const branchCreateValidation = (obj, setInputError, branchData) => {
  let hasError = false;

  if (!obj.branchName) {
    setInputError((prev) => ({ ...prev, branchName: true }));
    hasError = true;
  }

  if (!obj.contactNumber) {
    setInputError((prev) => ({ ...prev, contactNumber: true }));
    hasError = true;
  }
  if (!obj.description) {
    setInputError((prev) => ({ ...prev, description: true }));
    hasError = true;
  }
  if (!obj.type) {
    setInputError((prev) => ({ ...prev, type: true }));
    hasError = true;
  }

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  } else if (!emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.password && branchData == null) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (!obj.logoImage) {
    setInputError((prev) => ({ ...prev, logoImage: true }));
    hasError = true;
  }

  return hasError;
};

const updateUserValidation = (obj, setInputError, data) => {
  let hasError = false;

  if (!obj.firstName) {
    setInputError((prev) => ({ ...prev, firstName: true }));
    hasError = true;
  }
  if (!obj.lastName) {
    setInputError((prev) => ({ ...prev, lastName: true }));
    hasError = true;
  }

  if (!obj.contactNumber) {
    setInputError((prev) => ({ ...prev, contactNumber: true }));
    hasError = true;
  }
  if (!obj.assingedRole) {
    setInputError((prev) => ({ ...prev, assingedRole: true }));
    hasError = true;
  }

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  } else if (!emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }
  if (data?.type === "add") {
    if (!obj.password) {
      setInputError((prev) => ({ ...prev, password: true }));
      hasError = true;
    }
  }

  return hasError;
};

const forgotValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  return hasError;
};

const createTeamValidation = (obj, setInputError) => {
  let hasError = false;
  let errors = {};

  const requiredFields = [
    "email",
    "firstName",
    "lastName",
    "contact",
    "jobTitle",
    "gender",
    "address",
    "branchId",
    "startDate",
    "endDate",
    "note",
  ];

  requiredFields.forEach((field) => {
    if (!obj[field]) {
      errors[field] = true;
      hasError = true;
    }
  });

  if (obj.email && !emailRegex.test(obj.email)) {
    errors.isEmailValid = true;
    hasError = true;
  }

  if (!obj.salaryType) {
    errors.salaryType = true;
    hasError = true;
  } else if (obj.salaryType === "Percentage" && !obj.percentage) {
    errors.percentage = true;
    hasError = true;
  } else if (obj.salaryType === "Salary" && !obj.salary) {
    errors.salary = true;
    hasError = true;
  }

  setInputError(errors);
  console.log("Validation Errors:", errors);

  return !hasError;
};

const resetValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (!obj.confirmPass) {
    setInputError((prev) => ({ ...prev, confirmPass: true }));
    hasError = true;
  }

  if (obj.password !== obj.confirmPass) {
    setInputError((prev) => ({ ...prev, isPasswordValid: true }));
    hasError = true;
  }

  return hasError;
};

const categoryValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }

  // if (!obj.description) {
  //   setInputError((prev) => ({ ...prev, description: true }));
  //   hasError = true;
  // }

  return hasError;
};

export {
  loginValidation,
  signupValidation,
  forgotValidation,
  resetValidation,
  categoryValidation,
  branchCreateValidation,
  createTeamValidation,
  updateUserValidation,
};
